


























import { Component, Vue } from 'vue-property-decorator';

export interface DialogButton {
  text: string;
  action?: () => void | Promise<void>;
  isPrimary?: boolean;
}

@Component({
  name: 'dialog-modal',
})
export default class DialogModal extends Vue {
  public isVisible: boolean = false;
  public title: string = '';
  public message: string = '';
  public buttons: DialogButton[] = [];
  private closeOnOverlay: boolean = true;

  public async show(
    title: string,
    message: string,
    buttons: DialogButton[],
    closeOnOverlay: boolean = true
  ) {
    this.title = title;
    this.message = message;
    this.buttons = buttons;
    this.closeOnOverlay = closeOnOverlay;
    this.isVisible = true;
  }

  public close() {
    this.isVisible = false;
  }

  public handleOverlayClick() {
    if (this.closeOnOverlay) {
      this.close();
    }
  }

  public async handleButtonClick(button: DialogButton) {
    if (button.action && typeof button.action === 'function') {
      try {
        await button.action();
      } catch (error) {
        console.error('Erro ao executar ação do botão:', error);
      }
    }
    this.close();
  }
}
